module.exports = __webpack_public_path__ + "img/susie-king-taylor.4aa66cc9.png";